<template>
  <div class="file-content-tabs">
    <div :class="onlyTable ? 'hidden-header' : 'sticky-header'">
      <div class="content-header-wrapper has-side-bars">
        <div class="content-tabs">
          <div class="content-tab" :class="fileSelectedTab === 'table' && 'selected'" @click="toggleSelectedTab('table')">
            <div class="content-tab-icon table" />
            <div class="content-tab-text">{{ $t('file_table') }}</div>
          </div>
          <div
            v-if="!onlyTable"
            class="content-tab"
            :class="fileSelectedTab === 'chart' && 'selected'"
            @click="toggleSelectedTab('chart')"
          >
            <div class="content-tab-icon chart" />
            <div class="content-tab-text">{{ $t('file_chart') }}</div>
            <div v-if="isMobile && fileSelectedTab === 'chart'" class="chevron-icon" :class="mobileChartTypeOpen && 'open-file'" />
          </div>
          <div
            v-if="!onlyTable && haveMapRep"
            class="content-tab"
            :class="fileSelectedTab === 'map' && 'selected'"
            @click="toggleSelectedTab('map')"
          >
            <div class="content-tab-icon map" />
            <div class="content-tab-text">{{ $t('file_map') }}</div>
          </div>
        </div>
        <div v-if="unit" class="content-note">
          {{ $t('used_unit') + unit }}
        </div>
      </div>
    </div>
    <div v-if="fileSelectedTab === 'table'" class="file-details-block">
      <slot name="table-details" />
    </div>
    <div v-if="fileSelectedTab === 'chart'" class="file-details-block">
      <slot name="chart-details" />
    </div>
    <div v-if="fileSelectedTab === 'map'" class="file-details-block">
      <slot name="map-details" />
    </div>
  </div>
</template>

<script>
/**
 * Tabs for change visualization table/chart/map
 * @example [none]
 */
export default {
  name: 'FileContentTabs',
  props: {
    unit: {
      type: String,
    },
    mobileChartTypeOpen: {
      type: Boolean,
    },
    onlyTable: {
      type: Boolean,
      default: false,
    },
    fileSelectedTab: {
      type: String,
      default: 'table',
    },
    dataCard: {
      type: Object,
    },
    haveMapRep: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  methods: {
    toggleSelectedTab(value) {
      if (value !== this.fileSelectedTab) {
        this.$emit('change-selected-type', value)
      }
      if (value === 'chart') {
        this.$emit('toggle-mobile-type-edit')
      } else this.$emit('toggle-mobile-type-edit', false)
    },
  },
}
</script>

<style lang="stylus" scoped>
.file-content-tabs
  background-color: #fff

  .hidden-header
    display: none

  .sticky-header
    position: sticky
    // top: vw(162px)
    top: "calc(%s + %s + %s)" % ($header-height $subheader-height vw(60px))
    z-index: 5
    border-bottom: 1px solid $bcn-other-grey
    background-color: white

    .mobile &
      top: "calc(%s + %s + %s)" % ($header-height $subheader-height vw(60px))

  .content-header-wrapper
    display: flex
    justify-content: space-between
    align-items: center
    width: 100%

    .content-note
      m-font-size(16, 24)
      color: $grey-dark

      .mobile &
        display: none

    .content-tabs
      display: flex
      align-items: center
      gap: vw(10px)

      .content-tab
        display: flex
        align-items: center
        padding: vw(10px)
        border-bottom: 3px solid transparent
        cursor: pointer
        gap: vw(5px)

        &:hover
          border-bottom-color: $grey

        &.selected
          border-bottom-color: $corporate_color
          cursor: default

          .content-tab-icon
            &.table,
            &.chart,
            &.map
              background-color: $corporate_color

          .content-tab-text
            color: $corporate_color

        .content-tab-text
          m-font-size(16, 26)
          color: $grey

        .content-tab-icon
          &.table
            m-icon("table", 20)

          &.chart
            m-icon("chart", 20)

          &.map
            m-icon("map", 20)

        .chevron-icon
          m-icon("chevron-up-blue", 20)
          cursor: pointer
          transform: rotate(180deg)
          animation: 0.3s

        .open-file
          transform: rotate(0)
          animation-name: rotate

        @keyframes rotate
          from
            transform: rotate(180deg)

          to
            transform: rotate(0)

.file-details-block
  min-height: 200px
</style>
